/**
 * Created by evgeny on 26.08.2026
 */

const G5WindowsAds = function () {
    AdsPlugin.call(this, connector.G5WINDOWS, {
        cantLoadInParallel: true,
        cantLoadAndPlayInParallel: true,
        expirationPeriod: connector.utils.parseInterval("15 minutes")
    });
};

G5WindowsAds.prototype = Object.create(AdsPlugin.prototype);
G5WindowsAds.prototype.constructor = G5WindowsAds;

G5WindowsAds.isAppropriate = function () {
    return connector.platform.oneOf(connector.G5WINDOWS) && connector.config.g5windows && connector.config.g5windows.ads;
};

G5WindowsAds.prototype._connect = function (callback) {
    connector.platform.callNative("ads.initialize", {}, (code, response) => {
        const success = Boolean(response && response.success);

        callback(success ? connector.STATUS_CONNECTED : connector.STATUS_DISCONNECTED);
    });
};

G5WindowsAds.prototype._cacheAd = function (name, callback) {
    connector.platform.callNative("ads.preload", { placement: name }, (code, response) => {
        if (response && response.available) {
            callback(connector.CODE_SUCCEED);
        } else {
            callback(AdsPlugin.ERROR_LOADING_NO_ADS);
        }
    });
};

G5WindowsAds.prototype._playAd = function (name, ad, callback) {
    if (this.showing) {
        callback(name === AdsPlugin.REWARDED ? ERRORS.SHOW_REWARDED.AD_ALREADY_RUNNING : ERRORS.SHOW_INTERSTITIAL.AD_ALREADY_RUNNING);
        return;
    }

    this.showing = true;

    connector.platform.callNative("ads.show", { placement: name }, (code, response) => {
        this.showing = false;

        if (!response || !response.shown) {
            callback(name === AdsPlugin.REWARDED ? ERRORS.SHOW_REWARDED.NO_ADS : ERRORS.SHOW_INTERSTITIAL.NO_ADS);
            return;
        }

        if (name === AdsPlugin.REWARDED && !response.rewarded) {
            callback(ERRORS.SHOW_REWARDED.CLOSED_BY_USER);
            return;
        }

        callback(connector.CODE_SUCCEED);
    });
};
